import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DTC_ASSET_DAY_BASE_PATH } from '../../../../../../../../../features/dtcc/dtc-asset-day/dtc-asset-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/dtcc/asset/_asset')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'dtcc-asset-list',
        label: 'DTCC',
        to: DTC_ASSET_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
